import { Button, useToast } from "@agentsaas/ui";
import type { AgentId, ProjectId } from "@agentsaas/protocol";
import { useT } from "../app/i18n";
import { useServices } from "../app/services";

/**
 * 开发者面板（仅 mock 模式）：驱动脚本化的协作场景。
 * 也可以在 URL 上加 ?mock=collab，或在控制台用 window.__mock.collab。
 */
export function DevPanel({ pid }: { pid: string }) {
  const { t } = useT();
  const { mock } = useServices();
  const toast = useToast();
  if (!mock) return null;
  const agents = () => [...mock.agents.values()].map((s) => s.agent).filter((a) => a.projectId === pid);
  const done = () => toast.show({ message: t("dev.done"), tone: "success", duration: 1500 });
  const first = () => agents()[0];
  return (
    <details className="card devpanel" data-testid="dev-panel">
      <summary className="small muted">{t("dev.title")}</summary>
      <p className="small muted">{t("dev.hint")}</p>
      <div className="row">
        <Button size="sm" onClick={() => (mock.collab.seedTeam(pid as ProjectId), done())} data-testid="dev-seed">
          {t("dev.seed")}
        </Button>
        <Button
          size="sm"
          disabled={!agents().length}
          onClick={() => {
            const a = first();
            if (a) mock.collab.demoQuestion(pid as ProjectId, a.id);
            done();
          }}
          data-testid="dev-question"
        >
          {t("dev.question")}
        </Button>
        <Button
          size="sm"
          disabled={agents().length < 2}
          onClick={() => {
            const [a, b] = agents();
            if (a && b) mock.collab.demoMail(pid as ProjectId, a.id, b.id as AgentId);
            done();
          }}
          data-testid="dev-mail"
        >
          {t("dev.mail")}
        </Button>
        <Button size="sm" onClick={() => (mock.assets.seed(pid as ProjectId), done())} data-testid="dev-assets">
          {t("dev.assets")}
        </Button>
        <Button size="sm" onClick={() => (mock.assets.seedModel3d(pid as ProjectId), done())} data-testid="dev-model3d">
          {t("model3d.dev.seed")}
        </Button>
        <Button
          size="sm"
          onClick={() => {
            const art = mock.assets.artist(pid as ProjectId);
            mock.assets.generate(pid as ProjectId, art.id, { kind: "image", prompt: "Castle gate, isometric", name: "Castle gate", tags: ["building"] });
            done();
          }}
          data-testid="dev-generate"
        >
          {t("dev.generate")}
        </Button>
        <Button
          size="sm"
          disabled={!agents().length}
          onClick={() => {
            const a = first();
            if (a)
              mock.notifyProject({
                category: "agent_error",
                code: "notification.agent_error.failed",
                params: { agent: a.name, project: mock.projects.find((p) => p.id === pid)?.name ?? "", error: "agent.error" },
                link: `/p/${pid}/a/${a.id}`,
              });
            done();
          }}
          data-testid="dev-notify"
        >
          {t("dev.notify")}
        </Button>
      </div>
    </details>
  );
}
